import { render, staticRenderFns } from "./FilterItemActive.vue?vue&type=template&id=1ef31006&scoped=true&"
import script from "./FilterItemActive.vue?vue&type=script&lang=js&"
export * from "./FilterItemActive.vue?vue&type=script&lang=js&"
import style0 from "./FilterItemActive.vue?vue&type=style&index=0&id=1ef31006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef31006",
  null
  
)

export default component.exports